




































import { Component, Vue } from 'vue-property-decorator';
import { refsService } from '@/app/shared/refs.service';
import { ComplementaryModel } from '@/app/shared/models';
import DialogComplementary from '@/app/shared/components/dialogs/complementary.vue';
import DialogComplementaryDelete from '@/app/shared/components/dialogs/complementary-delete.vue';
@Component({
  components: {
    DialogComplementary,
    DialogComplementaryDelete,
  },
})
export default class DataTableComplementaries extends Vue {
  private get refs() {
    return refsService;
  }

  private get complementaries(): ComplementaryModel[] {
    return this.refs.modules.contract.complementaries || [];
  }
}
